import api from '@/apis'
import { createLatestOnly } from '@/utils/latestOnly'
import { createDataVersion } from '@/utils/dataVersion'

// Switching team starts a new request for the same card.
const skillset_request = createLatestOnly()

// DATA CURRENCY — an accepted write, recorded so a read already in flight cannot put the old value
// back. Both edits on this card are optimistic `v-model` writes, so the row is already showing the
// new value locally; without this a refresh answered from a pre-update snapshot reverted it for
// good. See utils/dataVersion.js.
const skillset_data = createDataVersion()

export default {
  state: {
    loading: true,
    headers: [
      { text: 'ID', value: 'user_id', sortable: false },
      { text: 'Name', value: 'name', sortable: false },
      { text: 'General Question', value: 'skill_1', sortable: false },
      { text: 'Illness Claims', value: 'skill_2', sortable: false },
      { text: 'Express Query', value: 'skill_3', sortable: false },
      { text: 'Others Claims', value: 'skill_4', sortable: false },
      { text: 'MPF', value: 'skill_5', sortable: false },
      { text: 'Payment', value: 'skill_6', sortable: false },
      { text: 'Doc Collection', value: 'skill_7', sortable: false },
      { text: 'Reserved', value: 'skill_8', sortable: false }
    ],
    items: []
  },
  mutations: {
    RESET_SKILLSET_CARD(state) {
      state.loading = true
      state.items = []
    },
    SET_SKILLSET_CARD_LOADING(state, payload) {
      state.loading = payload
    },
    SET_SKILLSET_CARD_ITEMS(state, payload) {
      state.items = payload
    }
  },
  actions: {
    async getSkillsetByTeamID({ commit }, payload) {
      const isLatest = skillset_request()
      const read = skillset_data.beginRead()
      try {
        const response = await api.getSkillsetByTeamID(payload)
        // A newer request of this kind owns the view now — see utils/latestOnly.js.
        if (!isLatest()) return
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: `Loading User's Skillset...`, loading: true })
        commit('RESET_SKILLSET_CARD')
        if (response.data.success) {
          const users_skill_set = response.data.data.map(user => {
            user.skillset = user.skillset === null ? [] : user.skillset
            return user
          })
          commit(
            'SET_SKILLSET_CARD_ITEMS',
            read.reconcile(users_skill_set, user => user.user_id)
          )
          commit('SET_SKILLSET_CARD_LOADING', false)
          commit('SET_SNACKBAR', { state: false })
        }
      } catch (error) {
        if (!isLatest()) return
        commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Server Error', icon: 'close', timeout: '2000' })
      } finally {
        read.settle()
      }
    },
    async updateUserSkillSet({ commit }, payload) {
      const { user_id, ...patch } = (payload && payload.params) || {}
      const write = skillset_data.beginWrite(user_id, patch)
      let answered = false
      try {
        const response = await api.updateSkillset(payload)
        answered = true
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Updating...', loading: true })
        if (response.data.success) {
          write.accepted()
          commit('SET_SNACKBAR', { status: true, color: 'success', text: 'Success', icon: 'check', timeout: '2000' })
        } else {
          commit('SET_SNACKBAR', { status: true, color: 'error', text: response.data.message, icon: 'close', timeout: '2000' })
        }
      } catch (error) {
        if (!answered) commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Server Error', icon: 'close', timeout: '2000' })
      }
    }
  }
}
